import React from "react";

import { ReferenciaContenido } from "../../../interfaces/ReferenciaContenido";
import VideosSlider from "../../molecules/videos-slider/videosSlider";

import "./videosRotator.scss";

const VideosRotator = (props: ReferenciaContenido) => {
  props.referenciaPlantillaContenido.push(
    props.referenciaPlantillaContenido[0]
  );
  return (
    <div className="o-videos-rotator">
      <div className="o-videos-rotator__upper">
        <h2 className="o-videos-rotator__upper-title">{props.tituloGeneral}</h2>
      </div>

      <div className="o-videos-rotator__content">
        <VideosSlider videos={props.referenciaPlantillaContenido} />
      </div>
    </div>
  );
};

export default VideosRotator;
